// import React, { useEffect, useState } from "react";
// import {
//   Document,
//   Page,
//   Text,
//   View,
//   Image,
//   StyleSheet,
//   Font,
// } from "@react-pdf/renderer";
// import { Link } from "react-router-dom";
// import { useTheme } from "../../config/themeContext";

// const styles = StyleSheet.create({
//   page: {
//     backgroundColor: "#FFFFFF",
//     position: "relative",
//   },
//   logoImageContainer: {
//     width: "25%",
//     height: "auto",
//     paddingLeft: "2%",
//     height: "10%",
//   },
//   logoImage: {
//     width: "100%",
//     height: "auto",
//     objectFit: "cover",
//     paddingLeft: "5%",
//     paddingTop: "5%",
//   },
//   firstPageMainImageContainer: {
//     position: "relative",
//     top: 0,
//     left: "15%",
//     height: "60%",
//     width: "70%",
//   },
//   firstPageMainImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   firstPageContentBox: {
//     width: "70%",
//     height: "30%",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "space-evenly",
//     alignItems: "left",
//     margin: "auto",
//   },
//   customerNameContainer: {
//     // display:'flex',
//     // flexDirection: 'row'
//   },
//   greeting: {
//     fontSize: 20,
//     color: "#154c79",
//     fontWeight: "bold",
//   },
//   customerName: {
//     fontSize: 40,
//     fontWeight: "bold",
//     color: "#154c79",
//   },
//   CustomerMessage: {
//     fontSize: 15,
//     color: "grey",
//   },

//   // NEW MRP STYLES - ONLY NUMBER STRIKETHROUGH
//   mrpText: {
//     color: "#3c6f99",
//     fontWeight: "bold",
//     fontSize: 15,
//     textAlign: "center",
//     // ✅ NO line-through
//   },
//   mrpNumber: {
//     color: "#3c6f99",
//     fontWeight: "bold",
//     fontSize: 15,
//     textAlign: "center",
//     textDecoration: "line-through", // ✅ ONLY NUMBER CUT
//   },

//   //For second Page ==>>
//   secondPageImageContainer: {
//     position: "relative",
//     top: 0,
//     left: "30%",
//     width: "60%",
//     height: "60%",
//   },
//   secondPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   secondPageRotatedContainer: {
//     position: "absolute",
//     top: 0,
//     left: "5%",
//     width: "30%",
//     height: "60%",
//     transform: "rotate(-90deg)",
//     width: "auto",
//     display: "flex",
//     flexDirection: "row",
//     gap: 10,
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   secondPageRotatedContainerProductPrice: {
//     color: "#154c79",
//     fontWeight: "bold",
//     fontSize: 25,
//     textAlign: "center",
//   },
//   secondPageRotatedContainerProductMRPPrice: {
//     color: "#3c6f99",
//     fontWeight: "bold",
//     fontSize: 15,
//     textAlign: "center",
//     display: "flex",
//     flexDirection: "row",
//   },
//   secondPageBottomContainer: {
//     marginLeft: "30%",
//     width: "60%",
//     height: "40%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   secondPageProdutName: {
//     fontSize: 25,
//     color: "#154c79",
//   },
//   secondPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },

//   //For Third Page ==>>
//   thirdPageImageContainer: {
//     position: "relative",
//     top: 0,
//     left: "25%",
//     width: "50%",
//     height: "70%",
//   },
//   thirdPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   thirdPageProductPriceContainer: {
//     display: "flex",
//     flexDirection: "row",
//     gap: 10,
//     // justifyContent: "center",
//     alignItems: "center",
//   },
//   thirdPageProductPrice: {
//     color: "#154c79",
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   thirdPageProductMRPPrice: {
//     color: "#3c6f99",
//     fontWeight: "bold",
//     fontSize: 15,
//     display: "flex",
//     flexDirection: "row",
//   },
//   thirdPageBottomContainer: {
//     marginLeft: "30%",
//     width: "60%",
//     height: "30%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   thirdPageProdutName: {
//     fontSize: 25,
//     color: "#154c79",
//   },
//   thirdPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },

//   //For Fourth Page ==>>
//   fourthPageImageContainer: {
//     position: "relative",
//     top: 0,
//     left: 0,
//     width: "50%",
//     height: "100%",
//   },
//   fourthPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   fourthPageRotatedContainer: {
//     position: "absolute",
//     top: "25%",
//     left: "30%",
//     width: "50%",
//     height: "30%",
//     transform: "rotate(-90deg)",
//     width: "auto",
//     display: "flex",
//     justifyContent: "space-evenly",
//     alignItems: "left",
//   },
//   fourthPageProdutName: {
//     fontSize: 25,
//     color: "#154c79",
//   },
//   fourthPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   fourthPageProductPriceContainer: {
//     display: "flex",
//     flexDirection: "row",
//     gap: 10,
//     // justifyContent: "center",
//     alignItems: "center",
//   },
//   fourthPageProductPrice: {
//     color: "#154c79",
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   fourthPageProductMRPPrice: {
//     color: "#3c6f99",
//     fontWeight: "bold",
//     fontSize: 15,
//     display: "flex",
//     flexDirection: "row",
//   },

//   //For Fifth Page ==>>
//   fifthPageImageContainer: {
//     position: "relative",
//     top: "20%",
//     left: "10%",
//     width: "50%",
//     height: "40%",
//   },
//   fifthPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   fifthPageproductNameContainer: {
//     position: "absolute",
//     top: "7.5%",
//     left: "10%",
//     width: "80%",
//     height: "10%",
//     display: "flex",
//     justifyContent: "flex-start",
//     alignItems: "middle",
//   },
//   fifthPageProdutName: {
//     fontSize: 25,
//     color: "#154c79",
//   },
//   fifthPageBottomContainer: {
//     position: "absolute",
//     bottom: "10%",
//     marginLeft: "10%",
//     width: "60%",
//     height: "30%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   fifthPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   fifthPageProductPriceContainer: {
//     display: "flex",
//     flexDirection: "row",
//     gap: 10,
//     // justifyContent: "center",
//     alignItems: "center",
//   },
//   fifthPageProductPrice: {
//     color: "#154c79",
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   fifthPageProductMRPPrice: {
//     color: "#3c6f99",
//     fontWeight: "bold",
//     fontSize: 15,
//     display: "flex",
//     flexDirection: "row",
//   },

//   //For Sixth Page ==>>
//   sixthPageImageContainer: {
//     position: "relative",
//     top: "15%",
//     left: "0%",
//     width: "50%",
//     height: "70%",
//   },
//   sixthPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   sixthPageProdutName: {
//     fontSize: 25,
//     color: "#154c79",
//   },
//   sixthPageRightContainer: {
//     position: "absolute",
//     top: "20%",
//     left: "55%",
//     width: "40%",
//     height: "60%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   sixthPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   sixthPageProductPriceContainer: {
//     display: "flex",
//     flexDirection: "row",
//     gap: 10,
//     // justifyContent: "center",
//     alignItems: "center",
//   },
//   sixthPageProductPrice: {
//     color: "#154c79",
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   sixthPageProductMRPPrice: {
//     color: "#3c6f99",
//     fontWeight: "bold",
//     fontSize: 15,
//     display: "flex",
//     flexDirection: "row",
//   },

//   //For Seventh Page ==>>
//   seventhPageImageContainer: {
//     position: "relative",
//     top: 0,
//     left: "50%",
//     width: "50%",
//     height: "100%",
//   },
//   seventhPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   seventhPageLeftContainer: {
//     position: "absolute",
//     top: "20%",
//     left: "5%",
//     width: "40%",
//     height: "60%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   seventhPageProdutName: {
//     fontSize: 25,
//     color: "#154c79",
//   },
//   seventhPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   seventhPageProductPriceContainer: {
//     display: "flex",
//     flexDirection: "row",
//     gap: 10,
//     // justifyContent: "center",
//     alignItems: "center",
//   },
//   seventhPageProductPrice: {
//     color: "#154c79",
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   seventhPageProductMRPPrice: {
//     color: "#3c6f99",
//     fontWeight: "bold",
//     fontSize: 15,
//     display: "flex",
//     flexDirection: "row",
//   },

//   //For Eight Page ==>>
//   eightPageImageContainer: {
//     position: "relative",
//     top: "20%",
//     left: "0%",
//     width: "50%",
//     height: "50%",
//   },
//   eightPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   eightPageproductNameContainer: {
//     position: "absolute",
//     top: "7.5%",
//     left: "10%",
//     width: "80%",
//     height: "10%",
//     display: "flex",
//     justifyContent: "flex-start",
//     alignItems: "middle",
//   },
//   eightPageProdutName: {
//     fontSize: 25,
//     color: "#154c79",
//   },
//   eightPageBottomContainer: {
//     position: "absolute",
//     bottom: "5%",
//     marginLeft: "10%",
//     width: "60%",
//     height: "25%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   eightPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   eighthPageProductPriceContainer: {
//     display: "flex",
//     flexDirection: "row",
//     gap: 10,
//     // justifyContent: "center",
//     alignItems: "center",
//   },
//   eightPageProductPrice: {
//     color: "#154c79",
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   eightPageProductMRPPrice: {
//     color: "#3c6f99",
//     fontWeight: "bold",
//     fontSize: 15,
//     display: "flex",
//     flexDirection: "row",
//   },

//   // Last Page Style =>
//   lastPageBackground: {
//     top: "5%",
//     left: "5%",
//     backgroundColor: "#FEF9F6",
//     width: "90%",
//     height: "90%",
//   },
//   lastPageUpperContainer: {
//     position: "absolute",
//     top: "0%",
//     left: "10%",
//     width: "80%",
//     height: "100%",
//     backgroundColor: "#FCF0E8",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   lastPageContentContainer: {
//     width: "90%",
//     height: "90%",
//     border: "2px solid #154c79",
//     display: "flex",
//     flexDirection: "column",
//     padding: "20% 10%",
//     color: "#154c79",
//     justifyContent: "space-around",
//     alignItems: "center",
//     flexWrap: "wrap",
//     textAlign: "center",
//     gap: 15,
//   },
//   lastPageLogoImageContainer: {
//     width: "30%",
//     height: "auto",
//     margin: "auto",
//   },
//   lastPageLogoImage: {
//     width: "100%",
//     height: "auto",
//   },
//   lastPageManagerDetailsContainer: {
//     display: "flex",
//     flexDirection: "column",
//     width: "100%",
//     fontSize: 15,
//   },
//   lastPageManagerNameAndNumberContainer: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "space-around",
//   },
//   lastPageManagerName: {
//     fontSize: 15,
//     fontWeight: "bold",
//   },
//   lastPageManagerPhoneNumber: {
//     fontSize: 15,
//   },
// });

// export const RunwayReady = ({ jsonData, vendor }) => {
//   console.log("PDF VENDOR Logo IS THIS:", vendor?.vendorDetails?.logo?.url);
//   console.log("PDF VENDOR Name IS THIS:", vendor?.vendorDetails?.name);

//   const [Data, setData] = useState();

//   useEffect(() => {
//     setData(jsonData);
//   }, [jsonData]);

//   console.log("This is the data of RunwayReady :=>", Data);

//   // Helper function to format price without decimals
//   const formatPrice = (price) => {
//     return Math.floor(price).toString();
//   };

//   return (
//     <Document>
//       {/* FIRST PAGE */}
//       <Page size="A4" style={styles.page}>
//         <View style={styles.logoImageContainer}>
//           <Image style={styles.logoImage} src="/blackberrysLogo.png" />
//         </View>
//         <View style={styles.firstPageMainImageContainer}>
//           <Image
//             style={styles.firstPageMainImage}
//             src="/image/frontPageImage.jpg"
//           />
//         </View>
//         <View style={[styles.firstPageContentBox]}>
//           <View style={[styles.customerNameContainer]}>
//             <Text style={styles.greeting}>Hello, </Text>
//             <Text style={styles.customerName}>
//               {Data?.Customer?.customerName}
//             </Text>
//           </View>
//           <Text style={styles.CustomerMessage}>
//             Based on your interests and recent activities, we've carefully
//             curated a range of items that we believe you'll love. Whether you're
//             looking for something specific or just browsing, we hope you find
//             inspiration within these pages.
//           </Text>
//         </View>
//       </Page>

//       {/* PRODUCT PAGES */}
//       {Data?.Product?.map((product, index) => {
//         const layoutIndex = index % 7;
//         const imageSrc =
//           product?.image && product?.image !== "N/A"
//             ? product?.image
//             : product?.productImage;
//         const showMrp = product?.price !== product?.mrp;

//         switch (layoutIndex) {
//           case 0: // SECOND PAGE
//             return (
//               <Page key={index} size="A4" style={styles.page}>
//                 <View style={styles.secondPageImageContainer}>
//                   <Image style={styles.secondPageImage} src={imageSrc} />
//                 </View>
//                 <View style={styles.secondPageRotatedContainer}>
//                   <Text style={styles.secondPageRotatedContainerProductPrice}>
//                     {formatPrice(product?.price)} Rs.
//                   </Text>
//                   {showMrp && (
//                     <View style={styles.secondPageRotatedContainerProductMRPPrice}>
//                       <Text style={styles.mrpText}>MRP </Text>
//                       <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
//                       <Text style={styles.mrpText}> Rs.</Text>
//                     </View>
//                   )}
//                 </View>
//                 <View style={styles.secondPageBottomContainer}>
//                   <Text style={styles.secondPageProdutName}>
//                     {product?.title}
//                   </Text>
//                   <Text style={styles.secondPageProdutDescription}>
//                     Experience the perfect blend of quality and style with our
//                     thoughtfully crafted products.
//                   </Text>
//                 </View>
//               </Page>
//             );

//           case 1: // THIRD PAGE
//             return (
//               <Page key={index} size="A4" style={styles.page}>
//                 <View style={styles.thirdPageImageContainer}>
//                   <Image style={styles.thirdPageImage} src={imageSrc} />
//                 </View>
//                 <View style={styles.thirdPageBottomContainer}>
//                   <Text style={styles.thirdPageProdutName}>
//                     {product?.title}
//                   </Text>
//                   <Text style={styles.thirdPageProdutDescription}>
//                     Experience the perfect blend of quality and style with our
//                     thoughtfully crafted products.
//                   </Text>
//                   <View style={styles.thirdPageProductPriceContainer}>
//                     <Text style={styles.thirdPageProductPrice}>
//                       {formatPrice(product?.price)} Rs.
//                     </Text>
//                     {showMrp && (
//                       <View style={styles.thirdPageProductMRPPrice}>
//                         <Text style={styles.mrpText}>MRP </Text>
//                         <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
//                         <Text style={styles.mrpText}> Rs.</Text>
//                       </View>
//                     )}
//                   </View>
//                 </View>
//               </Page>
//             );

//           case 2: // FOURTH PAGE
//             return (
//               <Page key={index} size="A4" style={styles.page}>
//                 <View style={styles.fourthPageImageContainer}>
//                   <Image style={styles.fourthPageImage} src={imageSrc} />
//                 </View>
//                 <View style={styles.fourthPageRotatedContainer}>
//                   <Text style={styles.fourthPageProdutName}>
//                     {product?.title}
//                   </Text>
//                   <Text style={styles.fourthPageProdutDescription}>
//                     Experience the perfect blend of quality and style with our
//                     thoughtfully crafted products.
//                   </Text>
//                   <View style={styles.fourthPageProductPriceContainer}>
//                     <Text style={styles.fourthPageProductPrice}>
//                       {formatPrice(product?.price)} Rs.
//                     </Text>
//                     {showMrp && (
//                       <View style={styles.fourthPageProductMRPPrice}>
//                         <Text style={styles.mrpText}>MRP </Text>
//                         <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
//                         <Text style={styles.mrpText}> Rs.</Text>
//                       </View>
//                     )}
//                   </View>
//                 </View>
//               </Page>
//             );

//           case 3: // FIFTH PAGE
//             return (
//               <Page key={index} size="A4" style={styles.page}>
//                 <View style={styles.fifthPageImageContainer}>
//                   <Image style={styles.fifthPageImage} src={imageSrc} />
//                 </View>
//                 <View style={styles.fifthPageproductNameContainer}>
//                   <Text style={styles.fifthPageProdutName}>
//                     {product?.title}
//                   </Text>
//                 </View>
//                 <View style={styles.fifthPageBottomContainer}>
//                   <Text style={styles.fifthPageProdutDescription}>
//                     Experience the perfect blend of quality and style with our
//                     thoughtfully crafted products.
//                   </Text>
//                   <View style={styles.fifthPageProductPriceContainer}>
//                     <Text style={styles.fifthPageProductPrice}>
//                       {formatPrice(product?.price)} Rs.
//                     </Text>
//                     {showMrp && (
//                       <View style={styles.fifthPageProductMRPPrice}>
//                         <Text style={styles.mrpText}>MRP </Text>
//                         <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
//                         <Text style={styles.mrpText}> Rs.</Text>
//                       </View>
//                     )}
//                   </View>
//                 </View>
//               </Page>
//             );

//           case 4: // SIXTH PAGE
//             return (
//               <Page key={index} size="A4" style={styles.page}>
//                 <View style={styles.sixthPageImageContainer}>
//                   <Image style={styles.sixthPageImage} src={imageSrc} />
//                 </View>
//                 <View style={styles.sixthPageRightContainer}>
//                   <Text style={styles.sixthPageProdutName}>
//                     {product?.title}
//                   </Text>
//                   <Text style={styles.sixthPageProdutDescription}>
//                     Experience the perfect blend of quality and style with our
//                     thoughtfully crafted products.
//                   </Text>
//                   <View style={styles.sixthPageProductPriceContainer}>
//                     <Text style={styles.sixthPageProductPrice}>
//                       {formatPrice(product?.price)} Rs.
//                     </Text>
//                     {showMrp && (
//                       <View style={styles.sixthPageProductMRPPrice}>
//                         <Text style={styles.mrpText}>MRP </Text>
//                         <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
//                         <Text style={styles.mrpText}> Rs.</Text>
//                       </View>
//                     )}
//                   </View>
//                 </View>
//               </Page>
//             );

//           case 5: // SEVENTH PAGE
//             return (
//               <Page key={index} size="A4" style={styles.page}>
//                 <View style={styles.seventhPageImageContainer}>
//                   <Image style={styles.seventhPageImage} src={imageSrc} />
//                 </View>
//                 <View style={styles.seventhPageLeftContainer}>
//                   <Text style={styles.seventhPageProdutName}>
//                     {product?.title}
//                   </Text>
//                   <Text style={styles.seventhPageProdutDescription}>
//                     Experience the perfect blend of quality and style with our
//                     thoughtfully crafted products.
//                   </Text>
//                   <View style={styles.seventhPageProductPriceContainer}>
//                     <Text style={styles.seventhPageProductPrice}>
//                       {formatPrice(product?.price)} Rs.
//                     </Text>
//                     {showMrp && (
//                       <View style={styles.seventhPageProductMRPPrice}>
//                         <Text style={styles.mrpText}>MRP </Text>
//                         <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
//                         <Text style={styles.mrpText}> Rs.</Text>
//                       </View>
//                     )}
//                   </View>
//                 </View>
//               </Page>
//             );

//           case 6: // EIGHTH PAGE
//             return (
//               <Page key={index} size="A4" style={styles.page}>
//                 <View style={styles.eightPageImageContainer}>
//                   <Image style={styles.eightPageImage} src={imageSrc} />
//                 </View>
//                 <View style={styles.eightPageproductNameContainer}>
//                   <Text style={styles.eightPageProdutName}>
//                     {product?.title}
//                   </Text>
//                 </View>
//                 <View style={styles.eightPageBottomContainer}>
//                   <Text style={styles.eightPageProdutDescription}>
//                     Experience the perfect blend of quality and style with our
//                     thoughtfully crafted products.
//                   </Text>
//                   <View style={styles.eighthPageProductPriceContainer}>
//                     <Text style={styles.eightPageProductPrice}>
//                       {formatPrice(product?.price)} Rs.
//                     </Text>
//                     {showMrp && (
//                       <View style={styles.eightPageProductMRPPrice}>
//                         <Text style={styles.mrpText}>MRP </Text>
//                         <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
//                         <Text style={styles.mrpText}> Rs.</Text>
//                       </View>
//                     )}
//                   </View>
//                 </View>
//               </Page>
//             );

//           default:
//             return null;
//         }
//       })}

//       {/* LAST PAGE */}
//       <Page size="A4" style={styles.page}>
//         <View style={styles.lastPageBackground} />
//         <View style={styles.lastPageUpperContainer}>
//           <View style={styles.lastPageContentContainer}>
//             <View style={styles.lastPageLogoImageContainer}>
//               <Image
//                 style={styles.lastPageLogoImage}
//                 src="/blackberrysLogo.png"
//               />
//             </View>

//             <View style={styles.lastPageManagerDetailsContainer}>
//               <View style={styles.lastPageManagerNameAndNumberContainer}>
//                 <Text style={styles.lastPageManagerName}>
//                   {Data?.Store?.storename}
//                 </Text>
//                 <Text style={styles.lastPageManagerPhoneNumber}>
//                   {Data?.Store?.storePhone}
//                 </Text>
//               </View>
//             </View>
//           </View>
//         </View>
//       </Page>
//     </Document>
//   );
// };

// export default RunwayReady;

import React, { useEffect, useState } from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  // Font,
} from "@react-pdf/renderer";
// import { Link } from "react-router-dom";
// import { useTheme } from "../../config/themeContext";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#FFFFFF",
    position: "relative",
  },

  // ✅ Make logo appear *on top of* the main image
  logoImageContainer: {
    position: "absolute", // changed from relative → absolute
    top: "20px", // adjust vertical position
    left: "50%", // center horizontally
    transform: "translateX(-50%)",
    width: "25%",
  },

  logoImage: {
    width: "100%",
    height: "auto",
    objectFit: "contain",
  },

  // background image covers whole page
  firstPageMainImageContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    zIndex: 1,
  },

  firstPageMainImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  // NEW MRP STYLES - ONLY NUMBER STRIKETHROUGH
  mrpText: {
    // color: "#3c6f99",
    fontWeight: "bold",
    fontSize: 20,
    // textAlign: "center",
    // ✅ NO line-through
  },
  mrpNumber: {
    // color: "#3c6f99",
    color: "grey",
    fontWeight: "bold",
    fontSize: 15,
    // textAlign: "center",
    textDecoration: "line-through", // ✅ ONLY NUMBER CUT
  },

  //For second Page ==>>
  secondPageImageContainer: {
    position: "relative",
    top: "15%",
    left: "0%",
    width: "50%",
    height: "70%",
  },
  secondPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  secondPageProdutName: {
    fontSize: 24,
    // color: "#154c79",
  },
  secondPageRightContainer: {
    position: "absolute",
    top: "20%",
    left: "55%",
    width: "40%",
    height: "60%",
    display: "flex",
    justifyContent: "center",
    gap: 30,
  },
  secondPageProdutDescription: {
    fontSize: 15,
    color: "grey",
    lineHeight: 2, // Adds space between lines (1.5x font size)
    letterSpacing: 0.5, // Adds space between characters (0.5pt)
    wordSpacing: 2, // Adds space between words (2pt)
  },
  secondPageProductPriceContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 10,
    // justifyContent: "center",
    alignItems: "center",
  },
  secondPageProductPrice: {
    // color: "#154c79",
    fontWeight: "bold",
    fontSize: 20,
  },
  secondPageProductMRPPrice: {
    // color: "#3c6f99",
    fontWeight: "bold",
    fontSize: 15,
    display: "flex",
    flexDirection: "row",
  },

  footer: {
    position: "absolute",
    // bottom: 10,
    bottom: 25,
    left: 0,
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: 20,
  },

  footerLine: {
    // position: "absolute",

    // left: 0,
    width: "70%",
    height: 1,
    backgroundColor: "#000",
  },

  footerText: {
    fontSize: 10,
    color: "#000",
  },

  //For third Page ==>>
  thirdPageImageContainer: {
    position: "relative",
    top: "15%",
    left: "50%",
    width: "50%",
    height: "70%",
  },
  thirdPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  thirdPageProdutName: {
    fontSize: 24,
    // color: "#154c79",
  },
  thirdPageLeftContainer: {
    position: "absolute",
    top: "20%",
    left: "5%",
    width: "40%",
    height: "60%",
    display: "flex",
    justifyContent: "center",
    gap: 30,
  },
  thirdPageProdutDescription: {
    fontSize: 15,
    color: "grey",
    lineHeight: 2, // Adds space between lines (1.5x font size)
    letterSpacing: 0.5, // Adds space between characters (0.5pt)
    wordSpacing: 2, // Adds space between words (2pt)
  },
  thirdPageProductPriceContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 10,
    // justifyContent: "center",
    alignItems: "center",
  },
  thirdPageProductPrice: {
    // color: "#154c79",
    fontWeight: "bold",
    fontSize: 20,
  },
  thirdPageProductMRPPrice: {
    color: "#3c6f99",
    fontWeight: "bold",
    fontSize: 15,
    display: "flex",
    flexDirection: "row",
  },

  // Last Page Style =>
  lastPageBackground: {
    top: "5%",
    left: "5%",
    backgroundColor: "#FEF9F6",
    width: "90%",
    height: "90%",
  },
  lastPageUpperContainer: {
    position: "absolute",
    top: "0%",
    left: "0%",
    width: "100%",
    height: "100%",
    // backgroundColor: "#FCF0E8",
    backgroundColor: "#fdf1e8",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  lastPageContentContainer: {
    width: "90%",
    height: "90%",
    border: "2px solid #28190c",
    display: "flex",
    flexDirection: "column",
    padding: "20% 10%",
    color: "#28190c",

    justifyContent: "space-around",
    alignItems: "center",
    flexWrap: "wrap",
    textAlign: "center",
    gap: 15,
  },
  lastPageLogoImageContainer: {
    width: "90%",
    height: "auto",
    margin: "auto",
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 10,
  },
  lastPageLogoImage: {
    width: "70%",
    height: "auto",
    // margin: "auto",
  },
  lastPageSlogan: {
    fontSize: 20,
    color: "#28190c",
    fontWeight: "bold",
    marginTop: 10,
  },
  lastPageManagerDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    fontSize: 15,
  },
  lastPageManagerNameAndNumberContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: 5,
  },
  lastPageManagerName: {
    fontSize: 15,
    fontWeight: "bold",
  },
  lastPageManagerPhoneNumber: {
    fontSize: 15,
  },
});

export const RunwayReady = ({ jsonData, vendor }) => {
  console.log("PDF VENDOR Logo IS THIS:", vendor?.vendorDetails?.logo?.url);
  console.log("PDF VENDOR Name IS THIS:", vendor?.vendorDetails?.name);

  const [Data, setData] = useState();

  useEffect(() => {
    setData(jsonData);
  }, [jsonData]);

  console.log("This is the data of RunwayReady :=>", Data);

  // Helper function to format price without decimals
  const formatPrice = (price) => {
    return Math.floor(price).toString();
  };

  // Helper: Truncate text to 30 chars + "..."
  const truncateText = (text, maxLength = 100) => {
    if (!text) return "Experience the perfect blend of quality and style...";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  return (
    <Document>
      {/* FIRST PAGE */}
      <Page size="A4" style={styles.page}>
        {/* <View style={styles.logoImageContainer}>
          <Image style={styles.logoImage} src="/blackberrysLogo.png" />
        </View> */}
        <View style={styles.firstPageMainImageContainer}>
          <Image
            style={styles.firstPageMainImage}
            src="/image/blackberrysFrontPageImage.png"
          />
        </View>
        {/* <View style={[styles.firstPageContentBox]}>
          <View style={[styles.customerNameContainer]}>
            <Text style={styles.greeting}>Hello, </Text>
            <Text style={styles.customerName}>
              {Data?.Customer?.customerName}
            </Text>
          </View>
          <Text style={styles.CustomerMessage}>
            Based on your interests and recent activities, we've carefully
            curated a range of items that we believe you'll love. Whether you're
            looking for something specific or just browsing, we hope you find
            inspiration within these pages.
          </Text>
        </View> */}
      </Page>

      {/* SECOND PAGE */}
      {Data?.Product?.map((product, index) => {
        const imageSrc =
          product?.image && product?.image !== "N/A"
            ? product?.image
            : product?.productImage;
        const showMrp = product?.price !== product?.mrp;
        const description = truncateText(
          product?.description ||
            "Experience the perfect blend of quality and style with our thoughtfully crafted products."
        );
        const isEvenIndex = index % 2 === 0; // TRUE = Second Page Layout, FALSE = Third Page Layout

        // ✅ PAGE 1 OF LOOP (Second Page Layout - Right Side)
        if (isEvenIndex) {
          return (
            <Page size="A4" style={styles.page}>
              <View style={styles.secondPageImageContainer}>
                <Image style={styles.secondPageImage} src={imageSrc} />
              </View>
              <View style={styles.secondPageRightContainer}>
                <Text style={styles.secondPageProdutName}>
                  {product?.title}
                </Text>
                <Text style={styles.secondPageProdutDescription}>
                  {description}
                </Text>
                <View style={styles.secondPageProductPriceContainer}>
                  <Text style={styles.mrpText}>MRP </Text>
                  <Text style={styles.secondPageProductPrice}>
                  Rs. {formatPrice(product?.price)}
                  </Text>
                  {showMrp && (
                    <View style={styles.secondPageProductMRPPrice}>
                      <Text style={styles.mrpNumber}>
                      Rs. {formatPrice(product?.mrp)}
                      </Text>
                      {/* <Text style={styles.mrpText}> Rs.</Text> */}
                    </View>
                 )}  
                </View>
              </View>
              <View style={styles.footer}>
                <View style={styles.footerLine} />
                <Text style={styles.footerText}>
                  {/* © 2025 - Blackberrys Menswear */}
                  {"\u00A9 2025 - Blackberrys Menswear"}
                </Text>
              </View>
            </Page>
          );
        }
        // {
        //    THIRD PAGE 
        // }
        return (
          <Page size="A4" style={styles.page}>
            <View style={styles.thirdPageImageContainer}>
              <Image style={styles.thirdPageImage} src={imageSrc} />
            </View>
            <View style={styles.thirdPageLeftContainer}>
              <Text style={styles.thirdPageProdutName}>{product?.title}</Text>
              <Text style={styles.thirdPageProdutDescription}>
                {description}
              </Text>
              <View style={styles.thirdPageProductPriceContainer}>
                <Text style={styles.mrpText}>MRP </Text>
                <Text style={styles.thirdPageProductPrice}>
                Rs. {formatPrice(product?.price)}
                </Text>
                {showMrp && (
                  <View style={styles.thirdPageProductMRPPrice}>
                    <Text style={styles.mrpNumber}>
                    Rs. {formatPrice(product?.mrp)} 
                    </Text>
                    {/* <Text style={styles.mrpText}> Rs.</Text> */}
                  </View>
               )}
              </View>
            </View>
            <View style={styles.footer}>
              <View style={styles.footerLine} />
              <Text style={styles.footerText}>
                © 2025 - Blackberrys Menswear
              </Text>
            </View>
          </Page>
        );
      })}

      {/* LAST PAGE */}
      <Page size="A4" style={styles.page}>
        <View style={styles.lastPageBackground} />
        <View style={styles.lastPageUpperContainer}>
          <View style={styles.lastPageContentContainer}>
            <View style={styles.lastPageLogoImageContainer}>
              <Image
                style={styles.lastPageLogoImage}
                src="/blackberrysLogo.png"
              />
              <Text style={styles.lastPageSlogan}>KEEP RISING</Text>
            </View>

            <View style={styles.lastPageManagerDetailsContainer}>
              <View style={styles.lastPageManagerNameAndNumberContainer}>
                <Text style={styles.lastPageManagerName}>
                  {Data?.Store?.storename}
                  {/* Ambeince Mall Gurgaon */}
                </Text>
                <Text style={styles.lastPageManagerPhoneNumber}>
                  {Data?.Store?.storePhone}
                  {/* 8837811541 */}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default RunwayReady;

// import React, { useEffect, useState } from "react";
// import {
//   Document,
//   Page,
//   Text,
//   View,
//   Image,
//   StyleSheet,
//   Font,
// } from "@react-pdf/renderer";
// import { useTheme } from "../../config/themeContext";

// const styles = StyleSheet.create({
//   page: {
//     backgroundColor: "#FFFFFF",
//     position: "relative",
//   },
//   logoImageContainer: {
//     width: "25%",
//     height: "auto",
//     paddingLeft: "2%",
//     height: "10%",
//   },
//   logoImage: {
//     width: "100%",
//     height: "auto",
//     objectFit: "cover",
//     paddingLeft: "5%",
//     paddingTop: "5%",
//   },
//   firstPageMainImageContainer: {
//     position: "relative",
//     top: 0,
//     left: "15%",
//     height: "60%",
//     width: "70%",
//   },
//   firstPageMainImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   firstPageContentBox: {
//     width: "70%",
//     height: "30%",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "space-evenly",
//     alignItems: "left",
//     margin: "auto",
//   },
//   customerNameContainer: {},
//   greeting: {
//     fontSize: 20,
//     color: "#154c79",
//     fontWeight: "bold",
//   },
//   customerName: {
//     fontSize: 40,
//     fontWeight: "bold",
//     color: "#154c79",
//   },
//   CustomerMessage: {
//     fontSize: 15,
//     color: "grey",
//   },
//   // ✅ PAGE 1 OF LOOP (Original SECOND PAGE - RIGHT SIDE)
//   secondPageImageContainer: {
//     position: "relative",
//     top: "15%",
//     left: "0%",
//     width: "50%",
//     height: "70%",
//   },
//   secondPageRightContainer: {
//     position: "absolute",
//     top: "20%",
//     left: "55%",
//     width: "40%",
//     height: "60%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   // ✅ PAGE 2 OF LOOP (Original THIRD PAGE - LEFT SIDE)
//   thirdPageImageContainer: {
//     position: "relative",
//     top: "15%",
//     right: "0%",
//     width: "50%",
//     height: "70%",
//   },
//   thirdPageLeftContainer: {
//     position: "absolute",
//     top: "20%",
//     left: "5%",
//     width: "40%",
//     height: "60%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   // SHARED STYLES FOR BOTH PAGES
//   productImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   productName: {
//     fontSize: 25,
//     color: "#154c79",
//   },
//   productDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   productPriceContainer: {
//     display: "flex",
//     flexDirection: "row",
//     gap: 10,
//     alignItems: "center",
//   },
//   productPrice: {
//     color: "#154c79",
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   mrpText: {
//     color: "#3c6f99",
//     fontWeight: "bold",
//     fontSize: 15,
//   },
//   mrpNumber: {
//     color: "#3c6f99",
//     fontWeight: "bold",
//     fontSize: 15,
//     textDecoration: "line-through",
//   },
//   productMRPPrice: {
//     color: "#3c6f99",
//     fontWeight: "bold",
//     fontSize: 15,
//     display: "flex",
//     flexDirection: "row",
//   },
//   // LAST PAGE STYLES (UNCHANGED)
//   lastPageBackground: {
//     top: "5%",
//     left: "5%",
//     backgroundColor: "#FEF9F6",
//     width: "90%",
//     height: "90%",
//   },
//   lastPageUpperContainer: {
//     position: "absolute",
//     top: "0%",
//     left: "10%",
//     width: "80%",
//     height: "100%",
//     backgroundColor: "#FCF0E8",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   lastPageContentContainer: {
//     width: "90%",
//     height: "90%",
//     border: "2px solid #154c79",
//     display: "flex",
//     flexDirection: "column",
//     padding: "20% 10%",
//     color: "#154c79",
//     justifyContent: "space-around",
//     alignItems: "center",
//     flexWrap: "wrap",
//     textAlign: "center",
//     gap: 15,
//   },
//   lastPageLogoImageContainer: {
//     width: "30%",
//     height: "auto",
//     margin: "auto",
//   },
//   lastPageLogoImage: {
//     width: "100%",
//     height: "auto",
//   },
//   lastPageManagerDetailsContainer: {
//     display: "flex",
//     flexDirection: "column",
//     width: "100%",
//     fontSize: 15,
//   },
//   lastPageManagerNameAndNumberContainer: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "space-around",
//   },
//   lastPageManagerName: {
//     fontSize: 15,
//     fontWeight: "bold",
//   },
//   lastPageManagerPhoneNumber: {
//     fontSize: 15,
//   },
// });

// export const RunwayReady = ({ jsonData, vendor }) => {
//   const [Data, setData] = useState(null);

//   useEffect(() => {
//     setData(jsonData);
//   }, [jsonData]);

//   // const products = Data?.Products || [];

//   const formatPrice = (price) => {
//     return price ? Math.floor(price).toString() : "0";
//   };

//   if (!Data) return null;

//   return (
//     <Document>
//       {/* 🎯 FIRST PAGE (Always) */}
//       <Page size="A4" style={styles.page}>
//         <View style={styles.logoImageContainer}>
//           <Image
//             style={styles.logoImage}
//             src={vendor?.vendorDetails?.logo?.url || "/blackberrysLogo.png"}
//           />
//         </View>
//         <View style={styles.firstPageMainImageContainer}>
//           <Image
//             style={styles.firstPageMainImage}
//             src="/image/frontPageImage.jpg"
//           />
//         </View>
//         <View style={styles.firstPageContentBox}>
//           <View style={styles.customerNameContainer}>
//             <Text style={styles.greeting}>Hello, </Text>
//             <Text style={styles.customerName}>
//               {Data?.Customer?.customerName || "Customer"}
//             </Text>
//           </View>
//           <Text style={styles.CustomerMessage}>
//             Based on your interests and recent activities, we've carefully
//             curated a range of items that we believe you'll love. Whether you're
//             looking for something specific or just browsing, we hope you find
//             inspiration within these pages.
//           </Text>
//         </View>
//       </Page>

//       {/* 🎯 LOOP: TWO PAGES REPEATING FOR ALL PRODUCTS */}
//       {Data?.Product?.map((product, index) => {
//         const imageSrc = product?.images?.[0]?.url || "/image/default-product.jpg";
//         const showMrp = product?.mrp && product?.mrp > product?.price;
//         const isEvenIndex = index % 2 === 0; // TRUE = Second Page Layout, FALSE = Third Page Layout

//         // ✅ PAGE 1 OF LOOP (Second Page Layout - Right Side)
//         if (isEvenIndex) {
//           return (
//             <Page key={`product-right-${index}`} size="A4" style={styles.page}>
//               <View style={styles.secondPageImageContainer}>
//                 <Image style={styles.productImage} src={imageSrc} />
//               </View>
//               <View style={styles.secondPageRightContainer}>
//                 <Text style={styles.productName}>{product?.title || "Product Name"}</Text>
//                 <Text style={styles.productDescription}>
//                   Experience the perfect blend of quality and style with our
//                   thoughtfully crafted products.
//                 </Text>
//                 <View style={styles.productPriceContainer}>
//                   <Text style={styles.productPrice}>
//                     {formatPrice(product?.price)} Rs.
//                   </Text>
//                   {showMrp && (
//                     <View style={styles.productMRPPrice}>
//                       <Text style={styles.mrpText}>MRP </Text>
//                       <Text style={styles.mrpNumber}>
//                         {formatPrice(product?.mrp)}
//                       </Text>
//                       <Text style={styles.mrpText}> Rs.</Text>
//                     </View>
//                   )}
//                 </View>
//               </View>
//             </Page>
//           );
//         }

//         // ✅ PAGE 2 OF LOOP (Third Page Layout - Left Side)
//         return (
//           <Page key={`product-left-${index}`} size="A4" style={styles.page}>
//             <View style={styles.thirdPageImageContainer}>
//               <Image style={styles.productImage} src={imageSrc} />
//             </View>
//             <View style={styles.thirdPageLeftContainer}>
//               <Text style={styles.productName}>{product?.title || "Product Name"}</Text>
//               <Text style={styles.productDescription}>
//                 Experience the perfect blend of quality and style with our
//                 thoughtfully crafted products.
//               </Text>
//               <View style={styles.productPriceContainer}>
//                 <Text style={styles.productPrice}>
//                   {formatPrice(product?.price)} Rs.
//                 </Text>
//                 {showMrp && (
//                   <View style={styles.productMRPPrice}>
//                     <Text style={styles.mrpText}>MRP </Text>
//                     <Text style={styles.mrpNumber}>
//                       {formatPrice(product?.mrp)}
//                     </Text>
//                     <Text style={styles.mrpText}> Rs.</Text>
//                   </View>
//                 )}
//               </View>
//             </View>
//           </Page>
//         );
//       })}

//       {/* 🎯 LAST PAGE (Always) */}
//       <Page size="A4" style={styles.page}>
//         <View style={styles.lastPageBackground} />
//         <View style={styles.lastPageUpperContainer}>
//           <View style={styles.lastPageContentContainer}>
//             <View style={styles.lastPageLogoImageContainer}>
//               <Image
//                 style={styles.lastPageLogoImage}
//                 src={vendor?.vendorDetails?.logo?.url || "/blackberrysLogo.png"}
//               />
//             </View>
//             <View style={styles.lastPageManagerDetailsContainer}>
//               <View style={styles.lastPageManagerNameAndNumberContainer}>
//                 <Text style={styles.lastPageManagerName}>
//                   {Data?.Store?.storename || "Store Name"}
//                 </Text>
//                 <Text style={styles.lastPageManagerPhoneNumber}>
//                   {Data?.Store?.storePhone || "Phone Number"}
//                 </Text>
//               </View>
//             </View>
//           </View>
//         </View>
//       </Page>
//     </Document>
//   );
// };

// export default RunwayReady;
